import { motion } from "framer-motion";
import { CSDLogo } from "../assets/data/icon_data";

const PageTransition = ({ children }) => {
  return (
    <>
      {/* Fixed Logo during transition */}
      <motion.div
        className="fixed inset-0 flex items-center justify-center pointer-events-none z-[10000]"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0, transition: { delay: 0.3, duration: 0.4 } }}
        exit={{ opacity: 1, transition: { duration: 0.4 } }}
      >
        <img src={CSDLogo} alt="Loading..." className="w-24 h-24 md:w-32 md:h-32 object-contain animate-pulse" />
      </motion.div>

      <motion.div
        className="slide-in"
        initial={{ y: "calc(100vh + 320px)" }}
        animate={{ y: "calc(100vh + 320px)" }}
        exit={{ y: "0vh" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <svg className="wave-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path d="M0,256L21.8,234.7C43.6,213,87,171,131,170.7C174.5,171,218,213,262,229.3C305.5,245,349,235,393,240C436.4,245,480,267,524,229.3C567.3,192,611,96,655,64C698.2,32,742,64,785,101.3C829.1,139,873,181,916,192C960,203,1004,181,1047,170.7C1090.9,160,1135,160,1178,149.3C1221.8,139,1265,117,1309,133.3C1352.7,149,1396,203,1418,229.3L1440,256L1440,320L1418.2,320C1396.4,320,1353,320,1309,320C1265.5,320,1222,320,1178,320C1134.5,320,1091,320,1047,320C1003.6,320,960,320,916,320C872.7,320,829,320,785,320C741.8,320,698,320,655,320C610.9,320,567,320,524,320C480,320,436,320,393,320C349.1,320,305,320,262,320C218.2,320,175,320,131,320C87.3,320,44,320,22,320L0,320Z"></path>
        </svg>
      </motion.div>
      <motion.div
        className="slide-out"
        initial={{ y: "0vh" }}
        animate={{ y: "-150vh" }}
        exit={{ y: "-150vh" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <svg className="wave-bottom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path d="M0,256L21.8,234.7C43.6,213,87,171,131,170.7C174.5,171,218,213,262,229.3C305.5,245,349,235,393,240C436.4,245,480,267,524,229.3C567.3,192,611,96,655,64C698.2,32,742,64,785,101.3C829.1,139,873,181,916,192C960,203,1004,181,1047,170.7C1090.9,160,1135,160,1178,149.3C1221.8,139,1265,117,1309,133.3C1352.7,149,1396,203,1418,229.3L1440,256L1440,320L1418.2,320C1396.4,320,1353,320,1309,320C1265.5,320,1222,320,1178,320C1134.5,320,1091,320,1047,320C1003.6,320,960,320,916,320C872.7,320,829,320,785,320C741.8,320,698,320,655,320C610.9,320,567,320,524,320C480,320,436,320,393,320C349.1,320,305,320,262,320C218.2,320,175,320,131,320C87.3,320,44,320,22,320L0,320Z"></path>
        </svg>
      </motion.div>
      
      {/* Page Content Animation */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="page-transition-content"
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
